export const defaultComparisonMetric = 'PerformanceMetrics';
